/**
 * EMPTY_VALUE — what a field renders when it has no value.
 *
 * A single constant rather than a literal scattered through the toolkit: the
 * glyph was an em-dash in five separate places, so changing it meant finding
 * all five. House style forbids the em-dash in emitted text, and a plain
 * hyphen carries the same meaning without it.
 *
 * Do NOT render an empty string instead. "No value" and "not loaded yet" and
 * "not rendered" all look identical when the cell is blank, and a dispatcher
 * reading a station profile cannot tell which one they are looking at.
 */
export const EMPTY_VALUE = '-';
